// Premium bee-tile backdrop — dense monogram grid with radial gold glow
// and soft top/bottom fade to blend with adjacent sections.
const BEE_TILE = "/images/bee-tile-original.png";

export default function BeeTileBackdrop({
  opacity = 0.35,
  size = "620px",
  fade = "both", // "both" | "none"
}) {
  return (
    <>
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url('${BEE_TILE}')`,
          backgroundRepeat: "repeat",
          backgroundSize: `${size} auto`,
          opacity,
          filter: "brightness(1.05) saturate(1.3)",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 40%, rgba(201,162,76,0.08) 0%, transparent 55%)",
        }}
      />
      {fade !== "none" && (
        <div
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to bottom, #0A0A0A 0%, transparent 15%, transparent 85%, #0A0A0A 100%)",
          }}
        />
      )}
    </>
  );
}
